import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "area_form" }
const _hoisted_2 = { class: "area_form_body" }
const _hoisted_3 = { class: "area_row" }
const _hoisted_4 = { class: "area_col_body" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "area_row" }
const _hoisted_8 = { class: "area_col_body" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "area_row" }
const _hoisted_12 = { class: "area_col_body" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { class: "area_row" }
const _hoisted_16 = { class: "area_col_body" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "area_row" }
const _hoisted_20 = { class: "area_col_body" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = ["textContent"]
const _hoisted_23 = { class: "area_row" }
const _hoisted_24 = { class: "area_col_body" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = ["textContent"]
const _hoisted_27 = { class: "area_row noPrint" }
const _hoisted_28 = { class: "area_col_body" }
const _hoisted_29 = { class: "area_file" }
const _hoisted_30 = { for: "area_file" }
const _hoisted_31 = { class: "area_row noPrint" }
const _hoisted_32 = { class: "area_col_body" }
const _hoisted_33 = { class: "file_list" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "area_row noPrint" }
const _hoisted_38 = { class: "area_col_body" }
const _hoisted_39 = { class: "file_list" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "연번")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", {
                textContent: _toDisplayString($setup.state.data.number)
              }, null, 8, _hoisted_6)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "담당 상담원")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", {
                textContent: _toDisplayString($setup.state.data.counselor)
              }, null, 8, _hoisted_10)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "성매매 유형")
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", {
                textContent: _toDisplayString($setup.state.data.type)
              }, null, 8, _hoisted_14)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "주민등록번호")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", {
                textContent: _toDisplayString($setup.CommonUtils.convertJumin($setup.state.data.clientDetailVO.jumin))
              }, null, 8, _hoisted_18)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "연락처")
          ], -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", {
                textContent: _toDisplayString($setup.CommonUtils.convertPhoneNum($setup.state.data.clientDetailVO.phone))
              }, null, 8, _hoisted_22)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "상담 부서")
          ], -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", {
                textContent: _toDisplayString($setup.state.data.consultDepartment)
              }, null, 8, _hoisted_26)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "첨부파일")
          ], -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _createElementVNode("input", {
                  id: "area_file",
                  type: "file",
                  placeholder: "",
                  multiple: "",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
                }, null, 32),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "file_box_wrap" }, "파일 첨부하기", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "file_upload_btn" }, "파일첨부", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "p_info" }, "※200M 이하 파일을 첨부해주세요.", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "첨부파일목록")
          ], -1)),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: idx
                }, [
                  _createElementVNode("div", {
                    class: "file_name",
                    onClick: ($event: any) => ($setup.downloadFile(item.file, item.realName))
                  }, [
                    _cache[11] || (_cache[11] = _createElementVNode("img", {
                      src: "img/file_ico.png",
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(item.realName), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("img", {
                      src: "img/file_down_ico.png",
                      alt: "",
                      class: "noPrint"
                    }, null, -1))
                  ], 8, _hoisted_34),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap noPrint",
                    onClick: ($event: any) => ($setup.fileRemove(item.idx))
                  }, "삭제", 8, _hoisted_36)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "area_col_head" }, [
            _createElementVNode("label", null, "녹취파일목록")
          ], -1)),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.recordList, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "file",
                  key: idx
                }, [
                  _createElementVNode("div", {
                    class: "file_name",
                    onClick: ($event: any) => ($setup.downloadFile(item.file, '녹취록.txt'))
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("img", {
                      src: "img/file_ico.png",
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(item.fileName), 1),
                    _cache[15] || (_cache[15] = _createElementVNode("img", {
                      src: "img/file_down_ico.png",
                      alt: "",
                      class: "noPrint"
                    }, null, -1))
                  ], 8, _hoisted_40),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap noPrint",
                    onClick: ($event: any) => ($setup.showSummary(item.summaryText))
                  }, "상세", 8, _hoisted_42),
                  _createElementVNode("button", {
                    class: "file_del icon_wrap noPrint",
                    onClick: ($event: any) => ($setup.removeSummary(item.idx))
                  }, "삭제", 8, _hoisted_43)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}